import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { GraduationCap, Shield, ClipboardList, Trophy } from "lucide-react";
import { Reveal } from "./Reveal";
import { CURRICULO } from "../data/siteData";

const TABS = [
  { id: "atleta", label: "Como Atleta", icon: Shield },
  { id: "comissao", label: "Comissão Técnica", icon: ClipboardList },
  { id: "conquistas", label: "Conquistas", icon: Trophy },
];

const Curriculo = () => {
  const [tab, setTab] = useState("atleta");

  return (
    <Reveal className="mb-14">
      <div data-testid="curriculo-section" className="rounded-3xl border border-white/10 bg-night/60 p-6 md:p-10">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
          <h3 className="font-display text-3xl uppercase tracking-wide text-white">
            Currículo do Professor
          </h3>
          <span className="inline-flex items-center gap-2 rounded-full bg-royal/60 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white">
            <GraduationCap size={16} className="text-gold" />
            {CURRICULO.licenca}
          </span>
        </div>

        <div className="mb-8 flex flex-wrap gap-2" role="tablist" aria-label="Currículo de Thales Affá">
          {TABS.map((t) => (
            <button
              key={t.id}
              role="tab"
              aria-selected={tab === t.id}
              data-testid={`curriculo-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors duration-200 ${
                tab === t.id
                  ? "bg-gold text-navy"
                  : "border border-white/15 text-white/70 hover:border-gold/50 hover:text-gold"
              }`}
            >
              <t.icon size={15} />
              {t.label}
            </button>
          ))}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={tab}
            data-testid="curriculo-panel"
            role="tabpanel"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3 }}
          >
            {tab === "atleta" && (
              <div className="flex flex-wrap gap-3">
                {CURRICULO.atleta.map((c) => (
                  <span
                    key={c}
                    className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-navy/70 px-4 py-2.5 text-sm font-semibold text-white/85"
                  >
                    <Shield size={15} className="text-lawn" />
                    {c}
                  </span>
                ))}
              </div>
            )}
            {tab === "comissao" && (
              <ul className="space-y-3">
                {CURRICULO.comissao.map((c) => (
                  <li
                    key={`${c.periodo}-${c.clube}`}
                    className="flex flex-col gap-1 rounded-xl border border-white/10 bg-navy/70 p-4 sm:flex-row sm:items-center sm:gap-5"
                  >
                    <span className="w-32 shrink-0 font-display text-xl tracking-wide text-gold">
                      {c.periodo}
                    </span>
                    <div>
                      <p className="font-heading text-sm font-semibold uppercase tracking-wide text-white">
                        {c.clube}
                      </p>
                      <p className="text-xs text-white/65">{c.funcao}</p>
                    </div>
                  </li>
                ))}
              </ul>
            )}
            {tab === "conquistas" && (
              <div className="grid gap-4 sm:grid-cols-2">
                {CURRICULO.conquistas.map((c) => (
                  <div
                    key={c}
                    className="flex items-center gap-4 rounded-xl border border-gold/30 bg-gradient-to-r from-royal/40 to-night p-5"
                  >
                    <Trophy size={28} className="shrink-0 text-gold" strokeWidth={1.8} />
                    <p className="font-heading text-sm font-semibold uppercase tracking-wide text-white">{c}</p>
                  </div>
                ))}
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </Reveal>
  );
};

export default Curriculo;
